var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowButtonRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E85626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8375 17.3448C20.9436 17.2355 21.0698 17.1488 21.2088 17.0896C21.3478 17.0305 21.497 17 21.6476 17C21.7982 17 21.9473 17.0305 22.0864 17.0896C22.2254 17.1488 22.3516 17.2355 22.4577 17.3448L28.1625 23.1725C28.2694 23.2808 28.3543 23.4097 28.4123 23.5518C28.4702 23.6938 28.5 23.8461 28.5 24C28.5 24.1539 28.4702 24.3062 28.4123 24.4482C28.3543 24.5903 28.2694 24.7192 28.1625 24.8275L22.4577 30.6552C22.3516 30.7645 22.2254 30.8512 22.0864 30.9104C21.9473 30.9695 21.7982 31 21.6476 31C21.497 31 21.3478 30.9695 21.2088 30.9104C21.0698 30.8512 20.9436 30.7645 20.8375 30.6552C20.7306 30.5469 20.6457 30.418 20.5877 30.2759C20.5298 30.1339 20.5 29.9816 20.5 29.8277C20.5 29.6738 20.5298 29.5215 20.5877 29.3795C20.6457 29.2374 20.7306 29.1085 20.8375 29.0002L25.7437 24L20.8375 18.9998C20.7306 18.8915 20.6457 18.7626 20.5877 18.6205C20.5298 18.4785 20.5 18.3262 20.5 18.1723C20.5 18.0184 20.5298 17.8661 20.5877 17.7241C20.6457 17.582 20.7306 17.4531 20.8375 17.3448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonRight);
export default __webpack_public_path__ + "static/media/arrow-button-right.0c42161a41b76ed9d2485a426ed59f8f.svg";
export { ForwardRef as ReactComponent };